// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button_button__JBBzO {
  display: flex;
  margin-top: 4px;
  padding: 8px 20px;
  border-radius: 6px;
  justify-content: center;
  align-items: center;
}
.Button_button__JBBzO:hover {
  opacity: 0.9;
}

.Button_button__JBBzO:disabled {
  color: white;
  background-color: #c2c2c2;
  border-color: transparent;
  cursor: not-allowed;
}
.Button_button__JBBzO:disabled:hover {
  opacity: 1;
}

.Button_error__LjGKB {
  background-color: #dc362e;
  border-color: transparent;
}

.Button_approve__QTYlw {
  background-color: #038f00;
  border-color: transparent;
}

.Button_primary__9MLUH {
  color: #00538f;
  background-color: white;
}
.Button_primary__9MLUH:not(:disabled):hover {
  color: white;
  background-color: #00538f;
}

.Button_fill__9OZyR {
  color: white;
  background-color: #00538f;
}`, "",{"version":3,"sources":["webpack://./src/components/Button/Button.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AACF;AACE;EACE,YAAA;AACJ;;AAGA;EACE,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;AAAF;AAEE;EACE,UAAA;AAAJ;;AAIA;EACE,yBAAA;EACA,yBAAA;AADF;;AAIA;EACE,yBAAA;EACA,yBAAA;AADF;;AAIA;EACE,cAAA;EACA,uBAAA;AADF;AAGE;EACE,YAAA;EACA,yBAAA;AADJ;;AAKA;EACE,YAAA;EACA,yBAAA;AAFF","sourcesContent":[".button {\n  display: flex;\n  margin-top: 4px;\n  padding: 8px 20px;\n  border-radius: 6px;\n  justify-content: center;\n  align-items: center;\n\n  &:hover {\n    opacity: 0.9;\n  }\n}\n\n.button:disabled {\n  color: white;\n  background-color: #c2c2c2;\n  border-color: transparent;\n  cursor: not-allowed;\n\n  &:hover {\n    opacity: 1;\n  }\n}\n\n.error {\n  background-color: #dc362e;\n  border-color: transparent;\n}\n\n.approve {\n  background-color: #038f00;\n  border-color: transparent;\n}\n\n.primary {\n  color: #00538f;\n  background-color: white;\n\n  &:not(:disabled):hover {\n    color: white;\n    background-color: #00538f;\n  }\n}\n\n.fill {\n  color: white;\n  background-color: #00538f;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `Button_button__JBBzO`,
	"error": `Button_error__LjGKB`,
	"approve": `Button_approve__QTYlw`,
	"primary": `Button_primary__9MLUH`,
	"fill": `Button_fill__9OZyR`
};
export default ___CSS_LOADER_EXPORT___;
